import {ThemeType} from "grommet";

const theme: ThemeType = {
    global: {
      colors: {
        brand: {
          dark: '#ffe137',
          light: '#ffe137',
        },
        background: {
          dark: '#111111',
          light: '#FFFFFF',
        },
        'background-back': {
          dark: '#111111',
          light: '#EEEEEE',
        },
        'background-front': {
          dark: '#222222',
          light: '#FFFFFF',
        },
        'background-contrast': {
          dark: '#FFFFFF11',
          light: '#11111111',
        },
        text: {
          dark: '#EEEEEE',
          light: '#333333',
        },
        'text-strong': {
          dark: '#FFFFFF',
          light: '#000000',
        },
        'text-weak': {
          dark: '#CCCCCC',
          light: '#444444',
        },
        'text-xweak': {
          dark: '#999999',
          light: '#666666',
        },
        border: {
          dark: '#444444',
          light: 'none',
        },
        control: 'brand',
        'active-background': 'background-contrast',
        'active-text': 'text-strong',
        'selected-background': 'brand',
        'selected-text': 'text-strong',
        'status-critical': '#FF4040',
        'status-warning': '#FFAA15',
        'status-ok': '#00C781',
        'status-unknown': '#CCCCCC',
        'status-disabled': '#CCCCCC',
        'graph-0': 'brand',
        'graph-1': 'status-warning',
      },
      font: {
        family: 'Avenir',
      },
      active: {
        background: 'active-background',
        color: 'active-text',
      },
      hover: {
        background: 'active-background',
        color: 'active-text',
      },
      selected: {
        background: '#326FAE',
        color: '#fff',
      },
      control: {
        border: {
          radius: '6px',
        },
      },
      drop: {
        border: {
          radius: '6px',
        },
      },
      breakpoints: {
        mobile: {
          value: 600,
        },
        small: {
          value: 900,
        },
      },
    },
  
    text: {
      small: { size: '14px' },
      medium: { size: '16px' },
      large: { size: '18px' },
      xsmall: { size: '12px' },
    },
    select: {
      control: {
        extend: 'border: 2px solid #326FAE; border-radius: 1px;background: #fff',
      },
      icons: {
        color: '#326FAE',
      },
    },
  
    chart: {},
    diagram: {
      line: {},
    },
    meter: {},
    button: {
      border: {
        radius: '6px',
      },
    },
    checkBox: {
      check: {
        radius: '5px',
      },
      toggle: {
        radius: '6px',
      },
      color: '#2F7549',
      border: {
        color: '#244F7C',
        width: '1px',
      },
    },
    radioButton: {
      border: {
        color: '#244F7C',
        width: '1px',
      },
      check: {
        radius: '10px',
        background: { color: '#fff' },
      },
      icons: {
        //@ts-ignore
        circle: () => (
          <svg viewBox='0 0 24 24' fill='#114A8F'>
            <circle cx='12' cy='12' r='8' />
          </svg>
        ),
      },
      color: '#244F7C',
      size: '20px',
    },
    //@ts-ignore
    formField: {
      border: {
        color: 'border',
        error: {
          color: {
            dark: 'white',
            light: 'status-critical',
          },
        },
        position: 'outer',
        style: 'solid',
        size: 'xsmall',
        side: 'all',
      },
      content: {
        pad: 'small',
      },
      disabled: {
        background: {
          color: 'status-disabled',
          opacity: 'medium',
        },
      },
      error: {
        color: 'status-critical',
        margin: {
          vertical: 'xsmall',
          horizontal: 'small',
        },
      },
      help: {
        color: 'dark-3',
        margin: {
          start: 'small',
        },
      },
      info: {
        color: 'text-xweak',
        margin: {
          vertical: 'xsmall',
          horizontal: 'small',
        },
      },
      label: {
        margin: {
          vertical: 'xsmall',
          horizontal: 'small',
        },
      },
      margin: {
        bottom: 'small',
      },
      round: '6px',
    },
    layer: {
      background: {
        dark: '#111111',
        light: '#FFFFFF',
      },
    },
    box: {
      extend: (): string => `
        .hideScrollBox::-webkit-scrollbar {display: none;}
        .hideScrollBox {
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }
      `,
    },
    textInput: {
      extend: (): string => 'font-weight: normal; font-size: 16px',
    },
    rangeInput: {
      track: {
        color: '#CCCCCC',
      },
      thumb: {
        color: '#114A8F',
      },
    },
    menu: {
      icons: {
        color: '#111111',
      },
    },
  };

  export default theme;